import { useMemo } from 'react';

/**
 * Hook para obtener historial de pagos y cuotas pendientes de un grupo de lotes (por id de grupo)
 * - Recibe el grupo (objeto lote grupal)
 * - Devuelve: { historialPagos, cuotasPendientes, esCredito, esContado }
 */
export function useGrupoCuotas(grupo: any, expenses: any[]) {
  return useMemo(() => {
    let historialPagos: any[] = [];
    let cuotasPendientes: any[] = [];
    let esCredito = false;
    let esContado = false;

    if (!grupo) return { historialPagos, cuotasPendientes, esCredito, esContado };

    if (grupo.paymentType === 'contado') {
      esContado = true;
      // Movimientos de contado asociados
      const idsGrupo = grupo.idLotes ? (Array.isArray(grupo.idLotes) ? grupo.idLotes : String(grupo.idLotes).split('-')) : [grupo.id];
      const movsContado = expenses.filter((e: any) => {
        if (e.tipo !== 'contado') return false;
        const lotesMov = Array.isArray(e.lotes) ? e.lotes : [e.lotes];
        return idsGrupo.some((id: string) => lotesMov.includes(id));
      });
      movsContado.forEach((mov: any) => {
        historialPagos.push({
          fecha: mov.fecha,
          concepto: mov.concepto,
          tipoPago: 'Contado',
          recibo: mov.referencia || '-',
          monto: mov.monto,
          estado: mov.estado || 'Pagado',
        });
      });
    }
    if (grupo.paymentType === 'pagos' || grupo.tipoVenta === 'Crédito' || grupo.status === 'crédito') {
      esCredito = true;
      // Historial de pagos
      (Array.isArray(grupo.payments) ? grupo.payments : []).forEach((p: any) => {
        if (p.type === 'abono' || p.type === 'enganche') {
          historialPagos.push({
            fecha: p.date,
            concepto: p.type === 'abono' ? 'Abono' : 'Enganche',
            tipoPago: 'Crédito',
            recibo: p.receipt || '-',
            monto: p.amount,
            estado: 'Pagado',
          });
        }
      });
      // Cuotas pendientes
      const numPagos = grupo.numberOfPayments || grupo.numeroPagos || grupo.numPayments || 0;
      const totalValue = grupo.totalValue || parseFloat(grupo.valorTotal) || 0;
      const enganche = (Array.isArray(grupo.payments) ? grupo.payments : []).find((p: any) => p.type === 'enganche')?.amount || 0;
      const saldo = totalValue - enganche;
      const cuotaMensual = numPagos > 0 ? saldo / numPagos : 0;
      const fechaVenta = new Date(grupo.saleDate || grupo.fechaVenta || new Date());
      for (let i = 1; i <= numPagos; i++) {
        const fechaVencimiento = new Date(fechaVenta);
        fechaVencimiento.setMonth(fechaVencimiento.getMonth() + i);
        const fechaVencimientoYMD = fechaVencimiento.toISOString().split('T')[0];
        // Buscar si existe un abono para esta cuota
        const pagada = (Array.isArray(grupo.payments) ? grupo.payments : []).some((p: any) =>
          p.type === 'abono' && String(p.cuotaNumero) === String(i) && p.cuotaFechaVencimiento === fechaVencimientoYMD
        );
        cuotasPendientes.push({
          cuota: i,
          fecha: fechaVencimientoYMD,
          monto: cuotaMensual,
          estado: pagada ? 'Pagada' : 'Próxima',
        });
      }
    }
    historialPagos.sort((a, b) => new Date(b.fecha).getTime() - new Date(a.fecha).getTime());
    return { historialPagos, cuotasPendientes, esCredito, esContado };
  }, [grupo, expenses]);
} 